import { render } from "./servicios.vue?vue&type=template&id=1215a185&scoped=true"
import script from "./servicios.vue?vue&type=script&lang=js"
export * from "./servicios.vue?vue&type=script&lang=js"

import "./servicios.vue?vue&type=style&index=0&id=1215a185&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\easyturno\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1215a185"]])

export default __exports__